import { ajax } from '@/api/ajax';

/**
 * @operationId addUsingPOST
 * @tags C端用户管理
 * @logan http://logan-gateway.test.logan.xiaopeng.local/xp-ass-tis-cn-boot/doc.html#/%E7%94%A8%E6%88%B7%E7%AE%A1%E7%90%86/C%E7%AB%AF%E7%94%A8%E6%88%B7%E7%AE%A1%E7%90%86/addUsingPOST
 */
export function addUsingPost() {
  return ajax({
    url: '/api/tis/web/user/add',
    method: 'post'
  });
}
